import './App.css';
import React, {Component} from 'react';
import Navigation from './Components/Navigation.js';
import Logo from './Components/Logo.js';
import ImageLinkForm from './Components/ImageLinkForm';
import Rank from './Components/Rank.js';
import FaceRecognition from './Components/FaceRecognition.js'
import Particles from 'react-particles-js';
import Signin from './Components/Signin';
import Register from './Components/Register';


const initialState = {
  input: '',
  imageUrl: '',
  box: {},
  route: 'signin',
  isSignedIn: false,
  user: {
    id: "",
    name: "",
    email: "",
    entries: 0,
    joined: ""
  }
};

class App extends Component{
  constructor(){
    super();
    this.state = initialState;
  }

  loadUser = (data) => {
    this.setState({
      user: {
        id: data.id,
        name: data.name,
        email: data.email,
        entries: data.entries,
        joined: data.joined
      }
    });
  }

  // componentDidMount(){
  //   fetch("http://localhost:5000/")
  //     .then(response => response.json())
  //     .then(data => console.log(data));
  // }

  // https://tse1.mm.bing.net/th?id=OIP.z0ytQisFsgUllYImR65ziwHaJ4&pid=Api
  // Mehrere Gesichter https://tse1.mm.bing.net/th?id=OIP.KfvdFKsGrgg4l_U_oNj9EwHaEK&pid=Api
  // Menschenmenge https://tse2.mm.bing.net/th?id=OIP.9Q-rAb61fV5DAmDTm2dLJAHaEK&pid=Api
  calculateFaceLocation = (data) => {
    //const clarifaiFace = data.outputs[0].data.regions[0].region_info.bounding_box;
    const image = document.getElementById('inputImage');
    const width = Number(image.width);
    const height = Number(image.height);
    //console.log(width, height);
    let facesArray = [];
    let boxValues = [];
    let i = 0;
    //Alle Box-Daten werden in ein Array geschrieben und anschließend in ein Objekt
    //Das Objekt enthält eine Berechnung, damit die Box später an der richtigen Stelle erzeugt wird
    while(data.outputs[0].data.regions[i] !== undefined)
    {
      facesArray[i] = data.outputs[0].data.regions[i].region_info.bounding_box;
      boxValues[i] = {
        leftCol: facesArray[i].left_col * width,
        topRow: facesArray[i].top_row * height,
        rightCol: width - (facesArray[i].right_col * width),
        bottomRow: height - (facesArray[i].bottom_row * height)
      };
      i++;
    }
    return boxValues;
  }

  displayFaceBox = (box) => {
    // console.log(box);
    this.setState({box: box});
  }

  // onClick event für den Detect Button, hier soll ein Bild detektiert werden
  onButtonSubmit = () =>{
    this.setState({imageUrl: this.state.input});
    // API ist im Backend, damit der Key nicht ersichtlich ist
    fetch("https://enigmatic-savannah-29731.herokuapp.com/imageurl", {
      method: "post",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        input: this.state.input
      })
    }).then(response => response.json())
      .then(response => {
          if(response){
            fetch("https://enigmatic-savannah-29731.herokuapp.com/image", {
              method: "put",
              headers: {"Content-Type": "application/json"},
              body: JSON.stringify({
                id: this.state.user.id
              })
          }).then(response => response.json())
            .then(count => {
              this.setState(Object.assign(this.state.user, {entries: count}))
            }).catch(console.log);
        }
          this.displayFaceBox(this.calculateFaceLocation(response));
        }).catch(err => console.log(err));
  }

  // Veränderung am Inputfeld ausgebn
  onInputChange = (event) =>{
    // console.log(event.target.value)
    this.setState({input: event.target.value});
  }

  onRouteChange = (route) => {
    if(route === 'signout'){
      this.setState(initialState);
    } else if (route === 'home') {
      this.setState({isSignedIn: true});
    }
    this.setState({route: route});
  }

  render(){
    const {isSignedIn, imageUrl, route, box} = this.state;
    return (
      <div>
      <Particles className='particles'
        params={{ particles:{number:{value:30,
          density:{enable:true, value_area:200}}}}}
      />
        <Navigation isSignedIn={isSignedIn} onRouteChange={this.onRouteChange} />
        <Logo />
        { route === 'home'
          ? <div>
              <Rank userName={this.state.user.name} userEntries={this.state.user.entries} />
              <ImageLinkForm onInputChange={this.onInputChange} onButtonSubmit={this.onButtonSubmit}/>
              <FaceRecognition box={box} imageUrl={imageUrl} />
            </div>
          : (
              route === 'signin'
              ? <Signin onRouteChange={this.onRouteChange} loadUser={this.loadUser} />
              : <Register onRouteChange={this.onRouteChange} loadUser={this.loadUser} />
            )
        }
      </div>
    );
  }
}

export default App;
